import React from "react";
import { ChartMainCard } from "../LeadsDashboardComponents/ChartsHeader";
import DataNotFound from "../ui/loader/data-not-found";
import InnerLoader from "../ui/loader/inner-loader";
import Trophy1Icon from "../icons/trophy-1";
// import { ChartMainCard } from "./ChartsHeader";
// import DataNotFound from "../ui/loader/data-not-found";
// import InnerLoader from "../ui/loader/inner-loader";
// import Trophy1Icon from "../icons/trophy-1";

const BRAND_COLORS = [
  "#F59E0B", // Amber
  "#22C55E", // Green
  "#EF4444", // Red
  "#06B6D4", // Cyan
  "#8B5CF6", // Violet
  "#EC4899", // Pink
  "#14B8A6", // Teal
  "#F97316", // Orange
  "#6366F1", // Indigo
  "#3B82F6", // Blue
];

const BrandBar = ({ dept, maxCount = 0, index = 0 }) => {
  const count = dept?.total_deals || 0;
  const widthPercent = (count / maxCount) * 100;
  const percentage = maxCount ? ((count / maxCount) * 100).toFixed(1) : 0;

  const brandColor = BRAND_COLORS[index % BRAND_COLORS.length];

  const getInitials = (name = "", limit = 3) =>
    name
      .trim()
      .split(" ")
      .filter(Boolean)
      .map((word) => word[0])
      .slice(0, limit)
      .join("")
      .toUpperCase();

  return (
    <div className="group py-3 border-b border-slate-100 hover:bg-slate-50 transition-all duration-200 cursor-pointer">
      {/* Top Row */}
      <div className="flex items-center justify-between mb-2">
        <div className="flex items-center gap-3">
          {/* Initials Badge */}
          <div
            className="w-9 h-9 flex items-center justify-center rounded-xl text-xs font-bold text-white shadow-sm transition-transform duration-200 group-hover:scale-105"
            style={{ backgroundColor: brandColor }}
          >
            {getInitials(dept?.brand)}
          </div>

          <span className="text-[13px] font-semibold text-slate-900">
            {dept?.brand}
          </span>
        </div>

        <div className="flex items-center gap-4">
          <span className="text-sm font-bold text-slate-900">{count}</span>

          <span className="text-[11px] text-slate-400 font-semibold min-w-[45px] text-right">
            {percentage}%
          </span>

          <span
            className="text-[12px] font-semibold"
            style={{ color: brandColor }}
          >
            ${dept?.total_value}
          </span>
        </div>
      </div>

      {/* Progress Bar */}
      <div className="w-full h-[6px] bg-slate-100 rounded-lg overflow-hidden">
        <div
          className="h-full rounded-lg transition-all duration-700 ease-out"
          style={{
            width: `${widthPercent}%`,
            backgroundColor: brandColor,
          }}
        />
      </div>
    </div>
  );
};

const DealsByCompanies = ({ brandData = [], brandLoading }) => {
  return (
    <ChartMainCard
      className={"col-span-4"}
      Icon={<Trophy1Icon />}
      iconColor={"bg-theme-green-light text-theme-green"}
      heading="Brands Performance"
      subHeading={"Analyze deals and revenue generated per brand"}
      height="100%"
    >
      {brandLoading ? (
        <InnerLoader />
      ) : (
        <>
          {brandData.length > 0 ? (
            <div className="max-h-[480px]  overflow-y-auto px-7">
              {/* {brandData?.map((item, index) => (
                <BrandBar
                  key={item.brand}
                  dept={item}
                  maxCount={brandData?.total_deal_count || 50}
                  index={index}
                />
              ))} */}
              {brandData?.map((item, index) => {
                const maxCount = brandData?.reduce(
                  (acc, d) => acc + (d.total_deals || 0),
                  0,
                );

                return (
                  <BrandBar
                    key={item.brand}
                    dept={item}
                    maxCount={maxCount}
                    index={index}
                  />
                );
              })}
            </div>
          ) : (
            <div className="flex items-center justify-center h-full">
              <DataNotFound title={"Brands"} />
            </div>
          )}
        </>
      )}
    </ChartMainCard>
  );
};

export default DealsByCompanies;
